/**
 * =============================================================================
 * Project: vue-boilerplate
 * Created Date: 2017-10-26, 11:38:36
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2017-11-07, 15:17:49
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */

import { mapActions } from 'vuex';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'Modal',
  props: ['modal'],

  methods: {
    ...mapActions(['toggleModal']),
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/Modal/component.js